import SignupAction from './Form/SignupAction';
import { useSignupContext } from './Form/useSignupContext';
import Template1 from './Templates/Template1';
import Template2 from './Templates/Template2';
import Template3 from './Templates/Template3';
import type { SignupProps, SignupStyles } from './types';

interface TemplateRendererProps {
  signupStyles: SignupStyles;
}

const safelyRenderTemplate = (template: string) => {
  if (!template) {
    return 'template-1';
  }

  if (!['template-1', 'template-2', 'template-3'].includes(template)) {
    return 'template-1';
  }

  return template;
};

const TemplateRenderer = ({ signupStyles }: TemplateRendererProps) => {
  const templateVariant = safelyRenderTemplate(signupStyles?.template);

  const Template: any = {
    'template-1': Template1,
    'template-2': Template2,
    'template-3': Template3,
  }[templateVariant];

  const { isSubmitting, autoFocus, email, setEmail, onEmailChange } = useSignupContext();

  return (
    <Template
      signupStyles={signupStyles}
      autoFocus={autoFocus}
      isSubmitting={isSubmitting}
      email={email}
      setEmail={setEmail}
      onEmailChange={onEmailChange}
    />
  );
};

const Signup = ({ signupStyles, type, premiumOfferId, onEmailChange, onSuccess, autoFocus }: SignupProps) => {
  if (!signupStyles) {
    return null;
  }

  return (
    <SignupAction
      type={type}
      premiumOfferId={premiumOfferId}
      onEmailChange={onEmailChange}
      onSuccess={onSuccess}
      autoFocus={autoFocus}
      bodyTextColor={signupStyles.bodyTextColor}
    >
      <TemplateRenderer signupStyles={signupStyles} />
    </SignupAction>
  );
};

export default Signup;
